import { render, staticRenderFns } from "./ListInstitutionsDocDigital.vue?vue&type=template&id=7cb78c96&"
import script from "./ListInstitutionsDocDigital.vue?vue&type=script&lang=js&"
export * from "./ListInstitutionsDocDigital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cb78c96')) {
      api.createRecord('7cb78c96', component.options)
    } else {
      api.reload('7cb78c96', component.options)
    }
    module.hot.accept("./ListInstitutionsDocDigital.vue?vue&type=template&id=7cb78c96&", function () {
      api.rerender('7cb78c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/lists/components/ListInstitutionsDocDigital.vue"
export default component.exports